import { render } from "./BannersEditor.vue?vue&type=template&id=ab4f3176&scoped=true"
import script from "./BannersEditor.vue?vue&type=script&lang=js"
export * from "./BannersEditor.vue?vue&type=script&lang=js"

import "./BannersEditor.vue?vue&type=style&index=0&id=ab4f3176&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab4f3176"]])

export default __exports__